module.exports = __webpack_public_path__ + "img/Open Link.aae57342.png";